import { onGetDateFormat } from "../../../../shared/utility"
import { catalogs } from "../../../../texts/esp/catalogs"

export const cleanData2Table = (data, nodata, users) => {

  let table = []
  if (data)
    table = data.map(item => {

      //const image = findImageResponsible(item.responsible_id, users)
      let step_id = item.fixed_integral_solution_step_id ? item.fixed_integral_solution_step_id : 1
      let priority = catalogs.process_priority.find(p => p.value === item.solution_priority)
      let percent = catalogs.process_percent.integral_solution.find(e => e.id === step_id)

      let data = {
        id: item.id_proc_integral_solution,
        step_id: step_id,
        business: item.business ? item.business : nodata,
        importance: item.fixed_importance ? item.fixed_importance : nodata,
        responsible: item.fixed_responsible ? item.fixed_responsible : nodata,
        fixed_payday_limit: item.fixed_payday_limit ? item.fixed_payday_limit : nodata,
        fixed_client_classification: item?.fixed_client_classification ?? nodata,
        fixed_client_responsible: item?.fixed_client_responsible ?? nodata,
        fixed_business_advisor: item?.fixed_business_advisor ?? nodata,
        fixed_client_associate: item?.fixed_client_associate ?? nodata,
        step: {
          id: step_id,
          color: step_id === 15 ? 'primary' : 'secondary',
          label: item.fixed_integral_solution_step ? item.fixed_integral_solution_step : nodata
        },
        priority: priority,
        percent: percent.value,
        status_id: item.process_semaphore_id,
        // image: image,
      }

      return data
    })

  return table
}

const findImageResponsible = (id, users) => {
  let temp = null

  if (id !== null && id !== undefined) {
    if (users.length > 0) {
      temp = users.filter(el => el.id_user === id)
    }
  }

  return temp && temp[0] ? temp[0].image : null
}